import { JSX } from 'react';
import { StatusChip } from '../../edit/components/NokMini/email-finder/components/StatusChip';
import { RefundStatus, refundStatus } from './refund-format';

/** A refund's Stripe status, drawn with the same chip as every other status in HQ. */
export const RefundStatusChip: (props: { status: string, dense?: boolean }) => JSX.Element =
    (props: { status: string, dense?: boolean }): JSX.Element => {
        const status: RefundStatus = refundStatus(props.status);

        return <StatusChip status={ status.tone } label={ status.label } dense={ props.dense } />;
    }
